import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ChevronIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6l6 6-6 6" />
  </svg>
)
